import React, { Component } from "react";
import AppWrapper from "./AppWrapper";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";
import {
  faArrowRight,
  faFolder,
  faFileAlt,
  faArrowLeft
} from "@fortawesome/pro-solid-svg-icons";

library.add(
  faLinkedin,
  faGithub,
  faArrowRight,
  faFolder,
  faFileAlt,
  faArrowLeft
);

class App extends Component {
  componentDidMount() {
    document.title = "Portfolio - Crio.Do";
  }
  render() {
    return <AppWrapper></AppWrapper>;
  }
}
export default App;
